module.exports = __webpack_public_path__ + "static/mic-a6d31dec16d2a159c797f3bce098016f.jpg";